import { combineReducers } from "@reduxjs/toolkit";
import { login } from "pages/login/services";
import userReducer from "pages/login/services";
import modalReducer from 'components/Modal/services';
import { userList } from "pages/userList/services";
import { categoryApi } from "pages/categories/services";
import { customerApi } from "pages/dashboard/services";
import { collectionPointsApi } from "pages/collectionPoints/services";
import { foodItemApi } from "pages/foodItems/services";
import { customerListApi } from "pages/customers/services";
import { manageAccountsApi } from "pages/manageAccounts/services";
import { timeSlotsApi } from "pages/timeSlots/services";
import { orderApis } from "pages/orders/services";
import { tablesApis } from "pages/tables/services";
import { pastOrderApis } from "pages/pastOrders/services";
import { ordersPanelApis } from "pages/serve/services";
import { calendarApi } from "pages/calendar/services";
import { stationsApi } from "pages/stations/services";
import { manageSettingsApi } from "pages/settings/ManageSettings/services";
import { profileApi } from "pages/profile/services";
import { vendorTimingApi } from "pages/restaurantTimings/services";
import { feedbackApis } from "pages/manageReviews/service";
import { inventoryApi } from "pages/inventory/services";
import { offersApi } from "pages/offers/services";
import { supportTicketApi } from "pages/supportTickets/services";
import { cashManagementApi } from "pages/cashManagement/services";

/******************* 
@purpose : root reducer
@return : combine reducers
******************/
export default () =>
    combineReducers({
        // fuelsData: fuelSlice,
        // [fuelApi.reducerPath]: fuelApi.reducer,
        modal: modalReducer,
        [login.reducerPath]: login.reducer,
        [userList.reducerPath]: userList.reducer,
        [categoryApi.reducerPath]: categoryApi.reducer,
        [customerApi.reducerPath]: customerApi.reducer,
        [collectionPointsApi.reducerPath]: collectionPointsApi.reducer,
        [foodItemApi.reducerPath]: foodItemApi.reducer,
        [customerListApi.reducerPath]: customerListApi.reducer,
        [manageAccountsApi.reducerPath]: manageAccountsApi.reducer,
        [timeSlotsApi.reducerPath]: timeSlotsApi.reducer,
        [orderApis.reducerPath]: orderApis.reducer,
        [pastOrderApis.reducerPath]: pastOrderApis.reducer,
        [tablesApis.reducerPath]: tablesApis.reducer,
        [ordersPanelApis.reducerPath]: ordersPanelApis.reducer,
        [calendarApi.reducerPath]: calendarApi.reducer,
        [stationsApi.reducerPath]: stationsApi.reducer,
        [manageSettingsApi.reducerPath]: manageSettingsApi.reducer,
        [profileApi.reducerPath]: profileApi.reducer,
        [vendorTimingApi.reducerPath]: vendorTimingApi.reducer,
        [feedbackApis.reducerPath]: feedbackApis.reducer,
        [inventoryApi.reducerPath]: inventoryApi.reducer,
        [offersApi.reducerPath]: offersApi.reducer,
        [supportTicketApi.reducerPath]: supportTicketApi.reducer,
        [cashManagementApi.reducerPath]: cashManagementApi.reducer,
        posData: userReducer,
    });

/******************* 
@purpose : RTK Query middlwares
@return : array of middlewares
******************/
export const getReducerMiddlewares = () => [
    // fuelApi.middleware,
    login.middleware,
    userList.middleware,
    categoryApi.middleware,
    customerApi.middleware,
    collectionPointsApi.middleware,
    foodItemApi.middleware,
    customerListApi.middleware,
    manageAccountsApi.middleware,
    timeSlotsApi.middleware,
    orderApis.middleware,
    pastOrderApis.middleware,
    tablesApis.middleware,
    ordersPanelApis.middleware,
    calendarApi.middleware,
    stationsApi.middleware,
    manageSettingsApi.middleware,
    profileApi.middleware,
    vendorTimingApi.middleware,
    feedbackApis.middleware,
    inventoryApi.middleware,
    offersApi.middleware,
    supportTicketApi.middleware,
    cashManagementApi.middleware
];
